import { jsonArrayMember, jsonMember, jsonObject } from 'typedjson';
import { Guid, Nillable } from '@web/utils';
import { AdminBrandCreateSocialMediaRequest } from './admin-brand-create-social-media.request';
import { AdminBrandStatus } from '../../enums/admin-brand-status';

@jsonObject
export class AdminBrandUpdateRequest {
  @jsonMember(String)
  public readonly name!: string;

  @jsonMember(String)
  public readonly description?: Nillable<string>;

  @jsonMember(String)
  public readonly homeUrl?: Nillable<string>;

  @jsonMember(String)
  public readonly logoFileId?: Nillable<Guid>;

  @jsonMember(String)
  public readonly illustrationFileId?: Nillable<Guid>;

  @jsonMember(String)
  public readonly status!: AdminBrandStatus;

  /* prettier-ignore */
  @jsonArrayMember(AdminBrandCreateSocialMediaRequest)
  public readonly socialNetworks?: Nillable<AdminBrandCreateSocialMediaRequest[]>;

  @jsonMember(String)
  public readonly slug?: Nillable<string>;

  public constructor(
    private readonly data: {
      name: string;
      description?: Nillable<string>;
      logoFileId?: Nillable<Guid>;
      illustrationFileId: Nillable<Guid>;
      status: AdminBrandStatus;
      homeUrl?: Nillable<string>;
      slug?: Nillable<string>;
      socialNetworks?: Nillable<AdminBrandCreateSocialMediaRequest[]>;
    },
  ) {
    this.name = this.data.name;
    this.description = this.data.description;
    this.logoFileId = this.data.logoFileId;
    this.illustrationFileId = this.data.illustrationFileId;
    this.status = this.data.status;
    this.homeUrl = this.data.homeUrl;
    this.slug = this.data.slug;
    this.socialNetworks = this.data.socialNetworks;
  }
}
